import React, { useState } from "react";
import "./CalculatorModal.css";

interface CalculatorModalProps {
  onClose: () => void;
}

const CalculatorModal: React.FC<CalculatorModalProps> = ({ onClose }) => {
  const [wattage, setWattage] = useState("");
  const [hours, setHours] = useState("");
  const [days, setDays] = useState("");
  const [kwh, setKwh] = useState<number>(3.58);

  const calculateKwh = () => {
    if (wattage && hours && days) {
      const result =
        (parseFloat(wattage) * parseFloat(hours) * parseFloat(days)) / 1000;
      setKwh(result);
    }
  };

  const handleHoursChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (!value || (parseFloat(value) >= 0 && parseFloat(value) <= 24)) {
      setHours(value);
    }
  };

  const handleDaysChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (!value || (parseFloat(value) >= 0 && parseFloat(value) <= 31)) {
      setDays(value);
    }
  };

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if ((e.target as HTMLDivElement).classList.contains("calculator-overlay")) {
      onClose();
    }
  };

  return (
    <div className="calculator-overlay" onClick={handleOverlayClick}>
      <div
        className="calculator-modal"
        style={
          {
            "--calculator-meter-bg": `url(${process.env.PUBLIC_URL}/meter.png.webp)`,
          } as React.CSSProperties
        }
      >
        <button className="close-button" onClick={onClose}>
          ✕
        </button>
        <h3>
          Maximum Electricity Usage (W)<span className="required">*</span>
        </h3>
        <input
          type="number"
          placeholder="ex : 60"
          value={wattage}
          onChange={(e) => setWattage(e.target.value)}
        />
        <h3>
          Hours Consumed per Day<span className="required">*</span>
        </h3>
        <input
          type="number"
          placeholder="Hour"
          value={hours}
          onChange={handleHoursChange}
          max="24"
        />
        <h3>
          Number of days<span className="required">*</span>
        </h3>
        <input
          type="number"
          placeholder="ex : 30"
          value={days}
          onChange={handleDaysChange}
          max="31"
        />

        <div className="bottom-section">
          <button className="calculate-button" onClick={calculateKwh}>
            CALCULATE
          </button>
          <div className="result-display">
            <span className="result-value">{kwh.toFixed(2)}</span>
            <div className="result-unit">
              <div className="result-unit1">kWh</div>
              <div className="result-unit2">Units</div>
            </div>
          </div>
        </div>

        <p className="result-description">
          Work out your estimated electricity cost easily. Enter the wattage of
          the lamp or equipment and the daily usage duration. The calculator
          will automatically calculate monthly electricity usage (kWh) and
          estimated cost.
        </p>
      </div>
    </div>
  );
};

export default CalculatorModal;
